import { ActionCreator, createAction, props } from "@ngrx/store";
import { TypedAction } from "@ngrx/store/src/models";
import { StoreActionTypes } from "../constants/StoreConstants";

export const ClearState: ActionCreator<StoreActionTypes, () => TypedAction<StoreActionTypes>> = createAction(
    StoreActionTypes.ClearState
);

export const SetCourseId = createAction(
    StoreActionTypes.SetCourseId,
    props<{ courseId: number }>()
);

export const GetSessionState = createAction(
    StoreActionTypes.SessionState
);